import { composeEntitiesListApiActions } from '@bp/admins-shared/features/entity';

import type { Preset } from '../../models';

export const ACTIONS_SCOPE = '[Page][Presets]';

const scope = `[API]${ ACTIONS_SCOPE }`;

export const PRESETS_LIST_API_ACTIONS = composeEntitiesListApiActions<Preset>(scope);
